<action-bar>
	<action-button (actionClick)="backToList()" [iconClass]="'fa fa-arrow-left'" [className]="'action-default'">Return
		to List</action-button>
	@if (allowAssignConsultant) {
	<action-button (actionClick)="assignClick()" [iconClass]="'fa fa-user-plus'" [className]="'action-primary'">Assign
		Consultant</action-button>
	}
	<action-button (actionClick)="additionalServices()" [iconClass]="'fa fa-plus'" [className]="'action-primary'"
		[disabled]="!allowAdditionalServices">Additional Services</action-button>
	<action-group [title]="'Actions'">
		<action-button (actionClick)="newAssessment()" [iconClass]="'fa fa-plus'">New Assessment</action-button>
		@if (allowStatusChange) {
		<action-button (actionClick)="showStatusChangeDialog()" [iconClass]="'fa fa-edit'">Make
			In-Process</action-button>
		}
		@if (allowEdit) {
		<action-button (actionClick)="editAssessment()" [iconClass]="'fa fa-edit'">Edit Assessment</action-button>
		}
		@if (allowDelete) {
		<action-button (actionClick)="deleteAssessment()" [iconClass]="'fa fa-trash-o'"
			[className]="'text-danger'">Delete Assessment</action-button>
		}
		@if (allowAttachmentPurge) {
		<action-button (actionClick)="purgeAttachments()" [iconClass]="'fa fa-user-times'"
			[className]="'text-danger'">Purge Attachments</action-button>
		}
	</action-group>
	@if (assessmentRequestPermissions.isAdmin()) {
	<action-group [title]="'Upload'">
		@if (assessmentRequestPermissions.isAdmin()) {
		<action-button [iconClass]="'fa fa-cloud-upload'" (actionClick)="uploadReports()">Upload Reports</action-button>
		}
		<!-- <action-button [iconClass]="'fa fa-cloud-upload'" (actionClick)="uploadResume()">Upload Resume</action-button>
      <action-button [iconClass]="'fa fa-cloud-upload'" (actionClick)="uploadJobDesc()">Upload Job Description</action-button> -->
	</action-group>
	}
	<action-group [title]="'Download'">
		@if (allowDownloadReports) {
		<action-button [iconClass]="'fa fa-cloud-download'" (actionClick)="downloadReports()"
			[disabled]="disableDownloadReports()">Download Reports</action-button>
		}
		@if (allowDownloadAssessmentRequest) {
		<action-button [iconClass]="'fa fa-cloud-download'" (actionClick)="downloadRequest()"
			[disabled]="disableDownloadAssessementRequest()">Download Request</action-button>
		}
		@if (allowDownloadResume) {
		<action-button [iconClass]="'fa fa-cloud-download'"
			(actionClick)="AttachmentService.download(model.resumeAttachmentId)"
			[disabled]="disableDownloadResume()">Download Resume</action-button>
		}
		@if (allowDownloadJobDescription) {
		<action-button [iconClass]="'fa fa-cloud-download'"
			(actionClick)="AttachmentService.download(model.jobDescriptionAttachmentId)"
			[disabled]="disableDownloadDescription()">Download Job Description</action-button>
		}
	</action-group>

	@if (assessmentRequestPermissions.isAdmin()) {
	<action-group [title]="'View'">
		@if (allowDownloadResume) {
		<action-button [iconClass]="'fa fa-eye'" (actionClick)="viewDocument(model.resumeAttachmentId)"
			[disabled]="disableDownloadResume()">View Resume</action-button>
		}
		@if (allowDownloadJobDescription) {
		<action-button [iconClass]="'fa fa-eye'" (actionClick)="viewDocument(model.jobDescriptionAttachmentId)"
			[disabled]="disableDownloadDescription()">View Job Description</action-button>
		}
	</action-group>
	}
	-
	@if (model.isConfidential) {
	<div style="margin-right: 200px; float: right; cursor: initial;" class="action-object green-background"><span
			style="padding-right:8px;"
			class="fa fa-lock"></span>{{model.isConfidential?'Confidential':'Non-Confidential'}}</div>
	}
</action-bar>

<ps-sections-container [showNav]="true">
	<!--              Client              -->
	<ps-section [sectionId]="'client-info'" [sectionTitle]="'Client'">
		<div class="row">
			<div class="col">
				<label class="form-control-label">Client Name</label>
				<div class="static-text">{{model.clientName}}</div>
			</div>
			<div class="col">
				<label class="form-control-label">Requested By</label>
				<div class="static-text">{{model.requestedByUserDisplayName}}</div>
			</div>
		</div>
		@if (settings) {
		<div style="margin:0px;" class="row">
			@if (settings.enableCostCenter) {
			<div class="customField">
				<label class="form-control-label">Cost Center</label>
				<div class="static-text">{{model.costCenterText}}</div>
			</div>
			}
			@if (settings.enableCostCenterOwner) {
			<div class="customField">
				<label class="form-control-label">Cost Center Owner</label>
				<div class="static-text">{{model.costCenterOwner}}</div>
			</div>
			}
			@if (settings.enableCompanyCode) {
			<div class="customField">
				<label class="form-control-label">Company Code</label>
				<div class="static-text">{{model.companyCode}}</div>
			</div>
			}
			@if (settings.enableGeneralLedger) {
			<div class="customField">
				<label class="form-control-label">General Ledger</label>
				<div class="static-text">{{model.generalLedger}}</div>
			</div>
			}
			@if (settings.enableActivityCenter) {
			<div class="customField">
				<label class="form-control-label">Activity Center</label>
				<div class="static-text">{{model.activityCenter}}</div>
			</div>
			}
			@if (settings.enableCandidateId) {
			<div class="customField">
				<label class="form-control-label">Candidate Id</label>
				<div class="static-text">{{model.customCandidateId}}</div>
			</div>
			}
			@if (settings.enablePo) {
			<div class="customField">
				<label class="form-control-label">Purchase Order</label>
				<div class="static-text">{{model.customPo}}</div>
			</div>
			}
		</div>
		}
	</ps-section>

	<!--              Candidate              -->
	<ps-section [sectionId]="'candidate-details'" [sectionTitle]="'Candidate'">
		<div class="card-accent">
			{{model.candidateType === "I" ? "Internal" : "External"}}
		</div>
		<div class="row">
			<div class="col">
				<label class="form-control-label">Name</label>
				<div class="static-text">{{model.candidateDisplayName}}</div>
			</div>
			@if (model.candidateType === 'I') {
			<div class="col">
				<label class="form-control-label">Current Position</label>
				<div class="static-text">{{model.candidatePosition}}</div>
			</div>
			}
		</div>
		<div class="row">
			<div class="col">
				<label class="form-control-label">Email</label>
				<div class="static-text">{{model.candidateEmail}}&nbsp;
					@if (model.candidateEmail) {
					<a [attr.href]="'mailto:' + model.candidateEmail"><i class="fa fa-envelope-o"></i></a>
					}
				</div>
			</div>
			<div class="col">
				<label class="form-control-label">Report Pronouns</label>
				<div class="static-text">{{model.candidatePronounDescription}}</div>
			</div>
		</div>
		<div class="row">
			<div class="col-6">
				<label class="form-control-label">Language Preference</label>
				<div class="static-text">{{model.candidateLanguageName}}</div>
			</div>
			<div class="col-6">
				<label class="form-control-label">Resume Available</label>
				<div class="static-text">{{((model.candidateNoResume === false || model.candidateNoResume === null) &&
					(model.resumeAttachmentId != null || model.resumeAttachmentId > 0)) | bool:"YN"}}</div>
			</div>
		</div>
	</ps-section>

	<!--              Assessment Purpose              -->
	<ps-section [sectionId]="'assessment-purpose'" [sectionTitle]="'Assessment Purpose'">
		<div class="card-accent">
			{{model.assessmentPurpose}}
		</div>
		<div class="row">
			<div class="col">
				<label class="form-control-label">Position Being Filled</label>
				<div class="static-text">{{model.positionDescription}}</div>
			</div>
			<div class="col">
				<label class="form-control-label">Position Level</label>
				<div class="static-text">{{model.positionLevelName}}</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<label class="form-control-label">Position Reports To</label>
				<div class="static-text">{{model.positionReportsTo}}</div>
			</div>
		</div>
		<div class="row">
			<div class="col-6">
				<label class="form-control-label">Number of Direct Reports</label>
				<div class="static-text">{{model.numberOfDirectReports}}</div>
			</div>
		</div>
	</ps-section>

	<!--              Position Competencies              -->
	<ps-section [sectionId]="'position-competencies'" [sectionTitle]="'Position Competencies'">
		<div class="row">
			<div class="col">
				<label class="form-control-label">Competency List</label>
				@if (model.competencies.length) {
				<competency-list [columns]="2" [competencies]="model.competencies"></competency-list>
				}
			</div>
		</div>
		<div class="row">
			<div class="col">
				<label class="form-control-label">Custom Competency</label>
				@if (model.customCompetencies) {
				<div class="static-text">
					{{model.customCompetencies}}
				</div>
				}
				@if (!model.customCompetencies) {
				<div class="static-text">
					None Provided
				</div>
				}
			</div>
		</div>

	</ps-section>

	<!--              Services Requested              -->
	<ps-section [sectionId]="'services-requested'" [sectionTitle]="'Services Requested'">
		<div class="row">
			<div class="col">
				<label class="form-control-label">Assessment Level Requested</label>
				<div class="static-text">{{model.assessmentLevelRequested}}</div>
			</div>
			<div class="col">
				<label class="form-control-label">Additional Services Required</label>
				@if (model.additionalServices.length > 0) {
				<div class="static-text">
					@for (service of model.additionalServices; track service) {
					<div>{{service.additionalService}}</div>
					}
				</div>
				}
				@if (!model.additionalServices || model.additionalServices.length === 0) {
				<div class="static-text">
					No Additional Services Required
				</div>
				}
			</div>
		</div>
	</ps-section>

	<!--              Assessment Proctoring              -->
	@if (settings?.enableVideoProctoring) {
	<ps-section [sectionId]="'assessment-proctoring'" [sectionTitle]="'Assessment Proctoring'">
		<div class="row">
			<div class="col">
				<label class="form-control-label">Video Proctoring</label>
				<div class="static-text">{{model.proctoringSelection || 'Not Provided'}}</div>
			</div>
		</div>
	</ps-section>
	}

	<!--              Feedback Recipients              -->
	<ps-section [sectionId]="'feedback-recipients'" [sectionTitle]="'Feedback Recipients'">
		<div class="row">
			<div class="col">
				<label class="form-control-label">Recipients List</label>
				@if (model.feedbackRecipients.length > 0) {
				<div>
					<table class="table table-sm">
						@for (recipient of model.feedbackRecipients; track recipient) {
						<tr class="static-text">
							<td>{{recipient.name}}</td>
							<td>Email:&nbsp;{{recipient.email}}</td>
							<td>Phone:&nbsp;{{recipient.phoneWork}}</td>
							<td>Contact for Debrief:&nbsp;{{recipient.verbal | bool:"YN"}}</td>
							<td>Report Notification:&nbsp;{{recipient.written | bool:"YN"}}</td>
						</tr>
						}
					</table>
				</div>
				}
				@if (!model.feedbackRecipients || model.feedbackRecipients.length === 0) {
				<div class="static-text">
					No Feedback Recipients
				</div>
				}
			</div>
		</div>
	</ps-section>

	<!--Questions/Comments-->
	<ps-section [sectionId]="'questions-comments'" [sectionTitle]="'Questions/Comments'">
		<div class="row">
			<div class="col">
				<label class="form-control-label">Questions/Concerns/Comments</label>
				@if (model.questionsComments) {
				<div class="static-text">
					{{model.questionsComments}}
				</div>
				}
				@if (!model.questionsComments) {
				<div class="static-text">
					None Provided
				</div>
				}
			</div>
		</div>
	</ps-section>

	<!--              Billing Contact              -->
	<ps-section [sectionId]="'billing-contact'" [sectionTitle]="'Billing Contact'">
		<div class="row">
			<div class="col">
				<label class="form-control-label">Name</label>
				<div class="static-text">{{model.billingContactDisplayName}}</div>
			</div>
			<div class="col">
				<label class="form-control-label">Email</label>
				<div class="static-text">{{model.billingContactEmail}}</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<label class="form-control-label">Address</label>
				<address class="static-text">
					{{model.billingContactAddress}}<br />
					@if (model.billingContactAddress2) {
					<span>{{model.billingContactAddress2}}<br /></span>
					}
					{{model.billingContactCity}},&nbsp;{{(model.billingContactCountryId ==
					196)?model.billingContactState:model.billingContactProvince}}&nbsp;{{model.billingContactZipCode}}<br />
					{{model.billingContactCountry}}
				</address>
			</div>
			<div class="col">
				<label class="form-control-label">Phone</label>
				<div class="static-text">{{model.billingContactPhone}}</div>
			</div>
		</div>
	</ps-section>

	<!--                Testing Schedule                -->
	@if (showTestingSchedule) {
	<ps-section [sectionId]="'testing-schedule'" [sectionTitle]="'Testing Schedule'">
		<div class="row">
			<div class="col">
				<label class="form-control-label">Testing Date</label>
				<div class="static-text">{{formatDate(model.testingDate)}}</div>
			</div>
			<div class="col">
				<label class="form-control-label">Interview Date</label>
				<div class="static-text">{{formatDate(model.interviewDate)}}</div>
			</div>
			<div class="col">
				<label class="form-control-label">Feedback Date</label>
				<div class="static-text">{{formatDate(model.feedbackDate)}}</div>
			</div>
		</div>
	</ps-section>
	}
</ps-sections-container>

@if (false) {
<div class="card">
	<div class="card-header">Debugging</div>
	<div class="card-body">
		<pre><code>{{model | json}}</code></pre>
	</div>
</div>
}